/** Shared homepage wording for the hero, metadata and generated sharing card. */
export const HOME_COPY = {
  headline: ["One business.", "One Twin.", "Any AI."],
  lead: "Your Twin connects the records spread across your systems. Ask who owes what, prepare the weekly review and check the sources behind each answer.",
  description: "Your Twin connects business records, relationships and rules into a shared understanding for your team and AI tools. Ask questions and check the sources.",
  closing: "Start with the question your team keeps chasing.",
} as const;
